import { SalesItemType } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';

export const SALES_ITEM_TYPE_ICON: Record<SalesItemType, NoddiIconName> = {
  [SalesItemType.SERVICE]: 'Wrench',
  [SalesItemType.PRODUCT]: 'Package',
  [SalesItemType.FEE]: 'CircleDollarSign'
};
